export default "__VITE_ASSET__BkOe6gmG__"